import React from 'react';
import { testimonials } from '../data/soklar';
export function Testimonials() {
  // Hidden until authentic SO KLAR reviews are added in data/soklar.ts (no buyers yet)
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-293" data-mp="3fycr5ou809bu">
      <div className="mx-auto max-w-6xl" data-id="element-294" data-mp="3azt4tnbpsviy">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-295" data-mp="3ayqaf5f6oaya">
          Vad <em className="text-red-700" data-id="element-296" data-mp="32061gvzfdfn9">lärarna</em> säger
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-297" data-mp="321z8wdhv43wb">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-298" data-mp="2s1qact0ee6dr">
              <blockquote className="flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-299" data-mp="2s3jfu4z9ykk6">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-300" data-mp="qa3pzab0h9q9">
                <span className="font-semibold text-slate-900" data-id="element-301" data-mp="q891xn4g11hy">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-302" data-mp="h4deiq6avw6a"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}